<template>
  <div id="eval-grad-period" class="admin-container admin-table-container">
    <h1 class="page-header">{{ $route.meta.title }}</h1>
    <div class="container">
      <div class="row row-v-c">
        <div class="col col-12">

          <div class="row tr-row">
            <div class="col col-2 th-cell">
              <label class="label">입학전형</label>
            </div>
            <div class="col col-6">
              <div class="input-group input-group-multiple input-group-small">
                <input-text
                  :readonly="true"
                  style="width: 100px"
                  v-model="evalGradPeriod.year" />
                <span
                  style="margin-right: 20px"
                  class="is-suffix">학년도</span>
                <input-text
                  :readonly="true"
                  style="width: 50px"
                  v-model="evalGradPeriod.semester" />
                <span
                  style="min-width: 50px"
                  class="is-suffix">학기</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-v-c">
        <div class="col col-12">
          <div class="row tr-row">
            <div class="col col-2 th-cell">
              <label class="label">서류 열람 기간</label>
            </div>
            <div class="col col-10">
              <div class="input-group input-group-multiple input-group-small">
                <input
                  style="width: 300px; height: 50%"
                  type="datetime-local"
                  v-model="evalGradPeriod.evalGradStartTime"
                   />
                <span
                  class="is-suffix">부터</span>
                <input
                  style="width: 300px; height: 50%; margin-left: 20px"
                  type="datetime-local"
                  v-model="evalGradPeriod.evalGradEndTime"
                />
                <span class="is-suffix">까지</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row tr-row">
        <div class="col col-9"></div>
        <div class="col col-3">
          <div class="button-group is-right">
            <button
              @click="_init"
              class="btn gradient-btn-2">초기화</button>
            <button
              @click="_updateEvalGradPeriod"
              class="btn btn-primary">저장</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apxAlert from '@/wrapper/apex-alert'
export default {
  name: 'eval-grad-period',
  props: {},
  mixins: [],
  data: () => ({
    evalGradPeriod: {
      oid: 0,
      evalGradStartTime: '',
      evalGradEndTime: '',
      year: '',
      semester: null
    }
  }),
  components: {},
  methods: {
    async _updateEvalGradPeriod () {
      await this.updateEvalGradPeriod(this.evalGradPeriod).then((res) => {
        this._evalGradPeriodInput(res)
        apxAlert.success(null, '서류 열람 기간이 저장 되었습니다.', '확인')
      }).catch(() => {})
    },
    _evalGradPeriodInput (data) {
      this.evalGradPeriod.oid = data.oid
      this.evalGradPeriod.year = data.year
      this.evalGradPeriod.semester = data.semester
      this.evalGradPeriod.evalGradStartTime = data.evalGradStartTime.replace(' ', 'T')
      this.evalGradPeriod.evalGradEndTime = data.evalGradEndTime.replace(' ', 'T')
    },
    async _init () {
      await this.getEvalGradPeriod().then(res => {
        this._evalGradPeriodInput(res)
      })
    }
  },
  async created () {
    await this._init()
  }
}
</script>

<style>
</style>
<style scoped>
</style>
